import { render, staticRenderFns } from "./bmgl.vue?vue&type=template&id=10955c0d&scoped=true&"
import script from "./bmgl.vue?vue&type=script&lang=js&"
export * from "./bmgl.vue?vue&type=script&lang=js&"
import style0 from "./bmgl.vue?vue&type=style&index=0&id=10955c0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10955c0d",
  null
  
)

export default component.exports